// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2iPY4","info":"UpdateTermsInfo_info__1TTV0"};